const readInt = (value) => {
    const parsed = Number.parseInt(String(value ?? ''), 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const getSiteAdminContext = () => {
    try {
        const ctx = window.SiteAdminContext || {};
        const fromWindow = {
            userId: readInt(ctx.userId),
            subscriberId: readInt(ctx.subscriberId),
        };

        if (fromWindow.userId || fromWindow.subscriberId) {
            return fromWindow;
        }

        const menu = document.getElementById('left-menu');
        return {
            userId: readInt(menu?.dataset?.userId),
            subscriberId: readInt(menu?.dataset?.subscriberId),
        };
    }
    catch {
        return { userId: null, subscriberId: null };
    }
};

export const scopedSiteAdminKey = (baseKey) => {
    const { userId, subscriberId } = getSiteAdminContext();
    const normalizedBase = String(baseKey ?? '').trim();
    if (!normalizedBase) {
        return null;
    }

    if (subscriberId && userId) {
        return `siteadmin:${subscriberId}:${userId}:${normalizedBase}`;
    }
    if (subscriberId) {
        return `siteadmin:${subscriberId}:${normalizedBase}`;
    }
    if (userId) {
        return `siteadmin:${userId}:${normalizedBase}`;
    }
    return null;
};

export const readScopedLocalStorage = (baseKey, { legacyKeys = [] } = {}) => {
    const key = scopedSiteAdminKey(baseKey);
    if (!key) {
        return null;
    }

    try {
        const current = localStorage.getItem(key);
        if (current !== null) {
            return current;
        }

        for (const legacyKey of legacyKeys) {
            const legacyValue = localStorage.getItem(legacyKey);
            if (legacyValue === null) {
                continue;
            }
            localStorage.setItem(key, legacyValue);
            localStorage.removeItem(legacyKey);
            return legacyValue;
        }
    }
    catch {
        // ignore storage access issues
    }

    return null;
};

export const writeScopedLocalStorage = (baseKey, value) => {
    const key = scopedSiteAdminKey(baseKey);
    if (!key) {
        return;
    }

    try {
        localStorage.setItem(key, String(value ?? ''));
    }
    catch {
        // ignore storage access issues
    }
};
